import _ from "lodash";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit, faPencil, faXmark } from "@fortawesome/free-solid-svg-icons";
import Helper from "../../../../utils/Helper";
import Image from "react-bootstrap/Image";

function MovementListItem({ item, onClickEdit, onClickDelete, index }) {
  const actionType = _.get(item, ["action_type"]);
  const stockCode = _.get(item, ["stock_code"]);
  const stockName = _.get(item, ["stock_name"]);
  const stockQuantity = _.get(item, ["stock_quantity"]);
  const stockPrice = _.get(item, ["stock_price"]);
  const stockMof = _.get(item, ["stock_mof"]);
  const stockCapPrice = _.get(item, ["stock_cap_price"],0);
  const stockAmount = _.get(item, ["amount"]);
  const marginAmount = _.get(item, ["margin_amount"]);

  return (
    <div className={clsx("movement-card-container")}>
      <div className={clsx("d-flex flex-row justify-content-between")}>
        <div>{actionType}</div>
        <div className={clsx("d-flex flex-row")}>
          <div className="pointer" onClick={(e) => onClickEdit(item, index)}>
            {/*<FontAwesomeIcon size="lg" icon={faPencil} />*/}
            <Image src="/img/icon/edit.png" style={{ width: "18px", objectFit: "contain" }} />
          </div>
          <div onClick={(e) => onClickDelete(item, index)} className={clsx("ms-3 pointer")}>
            {/*<FontAwesomeIcon size="lg" icon={faXmark} style={{ color: 'red', fontSize: "20px" }} />*/}
            <Image src="/img/icon/close.png" style={{ width: "18px", objectFit: "contain" }} />
          </div>
        </div>
      </div>
      {!_.isEmpty(stockCode) || !_.isEmpty(stockName) ? (
        <div>
          {stockName} ({stockCode})
        </div>
      ) : (
        false
      )}
      {!_.isNaN(marginAmount) && marginAmount != "" && marginAmount !== undefined ? (
        <div>Margin Amount: {Helper.formattedPrice(marginAmount)}</div>
      ) : (
        false
      )}
      {!_.isNaN(stockAmount) && stockAmount != "" && stockAmount !== undefined ? (
        <div>Amount: {Helper.formattedPrice(stockAmount)}</div>
      ) : (
        false
      )}
      {!_.isEmpty(stockPrice) ? (
        <div>
          {stockQuantity * 100} shares at {Helper.formattedPrice(stockPrice)}
        </div>
      ) : (
        false
      )}
      {!_.isEmpty(stockMof) ? (
        <div>
          Financing: {stockMof}%, Cap Price: {Helper.formattedPrice(stockCapPrice)}
        </div>
      ) : (
        false
      )}
    </div>
  );
}

export default MovementListItem;
